export const MAX_UPLOAD_MB = 25;

export type ValidationResult = { ok: true } | { ok: false; error: string };

export function validateUploadFile(file: File): ValidationResult {
  const okType =
    /image\/(jpeg|png)/.test(file.type) || /\.(jpe?g|png)$/i.test(file.name);
  if (!okType) return { ok: false, error: 'JPG or PNG only' };
  if (file.size > MAX_UPLOAD_MB * 1024 * 1024) {
    return { ok: false, error: `Over ${MAX_UPLOAD_MB} MB` };
  }
  return { ok: true };
}
